<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      class="form-control first-upper"
      autocomplete="off"
      :id="inputId"
      :disabled="disabled"
      v-model="inputValue"
      @change="emit"
      @input="emit"
      @blur="blur"
      @keyup.enter="emit"
      @keyup.delete="emit"
      @keydown="keydown"
    />
    <typeahead
      v-model="inputValue"
      :async-function="typeahead"
      :data="typeaheadData"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      :target="'#' + inputId"
      @input="selectTypeahead"
      @loaded="$emit('loaded-typehead')"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'LastNameInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Фамилия'
    },

    inputName: {
      default: 'fullname_last'
    },

    inputHint: {
      default: undefined
    },

    typeaheadItemKey: {
      type: String,
      default: 'value'
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-lastname-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-lastname`
      }

      return inputId
    }
  }
}
</script>
